import { lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AdminRoute, PrivateRoute, isAuthenticated } from "./PrivateRoute";
import AuthWrapper from "../pages/auth/AuthWrapper";
const HomePage = lazy(() => import("../pages/Webpage/home"));
const ContactPage = lazy(() => import("../pages/Webpage/contact"));
const Login = lazy(() => import("../pages/auth/Login"));
const Account = lazy(() => import("../pages/auth/Account"));
const Container = lazy(() => import("../component/layout/Container"));
const Details = lazy(() => import("../pages/auth/Details"));
const AwaitApproval = lazy(() => import("../pages/auth/AwaitApproval"));
const Dashboard = lazy(() => import("../pages/Admin/dashboard/Dashboard"));
const PreviousReference = lazy(() =>
  import("../pages/Admin/previousReference/PreviousReference")
);
const CourseName = lazy(() =>
  import("../pages/Admin/courseName/CourseName")
);
const QuestionBank = lazy(() =>
  import("../pages/Admin/questionBank/questionBank")
);
const DrawingQuestionBank = lazy(() =>
  import("../pages/Admin/drawingQuestionBank/drawingQuestionBank")
);
const AddDrawingQuestion = lazy(() =>
  import("../pages/Admin/addDrawingQuestion/addDrawingQuestion")
);
const EditDrawingQuestion = lazy(() =>
  import("../pages/Admin/editDrawingQuestion/editDrawingQuestion")
);
const AddQuestion = lazy(() =>
  import("../pages/Admin/addQuestion/addQuestion")
);
const EditQuestion = lazy(() =>
  import("../pages/Admin/editQuestion/editQuestion")
);
const ManageExam = lazy(() => import("../pages/Admin/manageExam/manageExam"));
const ExamAttempt = lazy(() =>
  import("../pages/Admin/examAttempt/ExamAttempt")
);
const CreateExam = lazy(() => import("../pages/Admin/createExam/createExam"));
const EditExam = lazy(() => import("../pages/Admin/editExam/editExam"));
const Category = lazy(() => import("../pages/Admin/category/Category"));
const Branch = lazy(() => import("../pages/Admin/branch/Branch"));
const StudentDashboard = lazy(() =>
  import("../pages/User/dashboard/Dashboard")
);
const StudentCategory = lazy(() => import("../pages/User/category/Category"));
const StudentExam = lazy(() => import("../pages/User/allExam/AllExam"));
const StudentHistory = lazy(() => import("../pages/User/history/History"));
const AdminStudyMaterial = lazy(() =>
  import("../pages/Admin/studyMaterial/StudyMaterial")
);
const StudentStudyMaterial = lazy(() =>
  import("../pages/User/studyMaterial/StudyMaterial")
);
const AdminProfile = lazy(() => import("../pages/Admin/profile/profile"));
const SubAdmin = lazy(() => import("../pages/Admin/subAdmin/subAdmin"));
const MockTest = lazy(() => import("../pages/User/mockTest/MockTest"));

const BasicInstruction = lazy(() =>
  import("../pages/User/basicInstruction/BasicInstruction")
);
const FinalExam = lazy(() =>
  import("../pages/User/studentFinalExam/StudentFinalExam")
);
const PartBReview = lazy(() =>
  import("../pages/User/partBReview/PartBReview")
);
const ExamResult = lazy(() => import("../pages/User/finalResult/FinalResult"));
const StudentProfile = lazy(() => import("../pages/User/profile/Profile"));

const HomeGate = () => {
  if (!isAuthenticated()) return <HomePage />;

  try {
    const data = localStorage.getItem("userData");
    if (!data) return <Navigate replace to="/login" />;

    const userData = JSON.parse(data);

    if (userData?.isActive === false || userData?.isActive === 0) {
      return <Navigate replace to="/approval" />;
    }

    if (userData?.role === "user") return <Navigate replace to="/student" />;
    if (userData?.role === "admin" || userData?.role === "subadmin") {
      return <Navigate replace to="/admin" />;
    }

    return <Navigate replace to="/admin" />;
  } catch (e) {
    return <Navigate replace to="/login" />;
  }
};

function Router() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<HomeGate />} />
        <Route path="/contact" Component={ContactPage} />

        <Route element={<AuthWrapper />}>

          <Route path="/approval" Component={AwaitApproval} />
          <Route path="/login" Component={Login} />
          <Route path="/account" Component={Account} />
          <Route path="/details" Component={Details} />
        </Route>


        <Route element={<PrivateRoute />}>
          <Route element={<AdminRoute />}>
            <Route path="admin/" element={<Container />}>
              <Route index element={<Dashboard />} />
              <Route path="/admin/question-bank" element={<QuestionBank />} />
              <Route
                path="/admin/drawing-question-bank"
                element={<DrawingQuestionBank />}
              />
              <Route
                path="/admin/add-drawing-question"
                element={<AddDrawingQuestion />}
              />
              <Route
                path="/admin/edit-drawing-question/:id"
                element={<EditDrawingQuestion />}
              />
              <Route path="/admin/add-question" element={<AddQuestion />} />
              <Route
                path="/admin/edit-question/:id"
                element={<EditQuestion />}
              />
              <Route path="/admin/manage-exam" element={<ManageExam />} />
              <Route path="/admin/exam-attempt/:id" element={<ExamAttempt />} />
              <Route path="/admin/create-exam" element={<CreateExam />} />
              <Route path="/admin/edit-exam/:id" element={<EditExam />} />
              <Route path="/admin/category" element={<Category />} />
              <Route path="/admin/branch" element={<Branch />} />
              <Route path="/admin/profile" element={<AdminProfile />} />
              <Route path="/admin/subAdmin" element={<SubAdmin />} />
              <Route
                path="/admin/previous-reference"
                element={<PreviousReference />}
              />
              <Route
                path="/admin/course-name"
                element={<CourseName />}
              />
              <Route
                path="/admin/study-material"
                element={<AdminStudyMaterial />}
              />
              <Route path="/admin/category-review" element={<StudentCategory />} />
              <Route
                path="/admin/category-review/gat"
                element={<StudentCategory />}
              />
              <Route
                path="/admin/category-review/cat"
                element={<StudentCategory />}
              />

            </Route>
            <Route path="/admin/mock-test/:examId" element={<MockTest />} />
          </Route>

          <Route path="student/" element={<Container />}>
            <Route index element={<StudentDashboard />} />
            <Route path="/student/all-exam" element={<StudentExam />} />
            <Route path="/student/category" element={<StudentCategory />} />
            <Route path="/student/category/gat" element={<StudentCategory />} />
            <Route path="/student/category/cat" element={<StudentCategory />} />
            <Route path="/student/history" element={<StudentHistory />} />
            <Route
              path="/student/study-material"
              element={<StudentStudyMaterial />}
            />
            <Route path="/student/profile" element={<StudentProfile />} />
          </Route>
          <Route path="/student/mock-test/:examId" element={<MockTest />} />
          <Route
            path="/student/basic-instruction/:Id"
            element={<BasicInstruction />}
          />
          <Route path="/student/mock-test/:Id" element={<MockTest />} />
          <Route
            path="/student/basic-instruction/:Id"
            element={<BasicInstruction />}
          />
          <Route path="/student/final-exam/:Id" element={<FinalExam />} />
          <Route
            path="/student/part-b-review/:paperId"
            element={<PartBReview />}
          />
          <Route path="/student/final-result" element={<ExamResult />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
